import { HomeIcon, TimerIcon, SettingsIcon, TrendIcon } from '../icons';
import { LccRole } from '../auth/types';
import { ModuleDefinition } from './modules';

/**
 * Registro de pantallas de Gestion Humana - mismo patron que
 * shared/config/modules.ts (Control Operativo), pero independiente: cada
 * aplicacion de la Suite tiene su propio catalogo de pantallas, su propio
 * set de Admin-only y su propio default por Rol (ver la decision confirmada:
 * el Rol es POR APLICACION, no global).
 *
 * FASE 1 (este entregable): solo Inicio + Configuracion (Usuarios). "Horas
 * Extra" queda como Proximamente hasta la siguiente fase - cuando se
 * desarrolle, solo hace falta cambiar su status a 'active' aqui.
 */
export const HR_MODULES: ModuleDefinition[] = [
  { id: 'hr-home', label: 'Inicio', path: '/gestion-humana', icon: HomeIcon, inBottomNav: true, status: 'active' },
  { id: 'overtime', label: 'Horas Extra', path: '/gestion-humana/horas-extra', icon: TimerIcon, inBottomNav: true, status: 'active' },
  { id: 'results', label: 'Resultados Financieros', path: '/gestion-humana/resultados', icon: TrendIcon, inBottomNav: true, status: 'active' },
  { id: 'hr-settings', label: 'Configuración', path: '/gestion-humana/configuracion', icon: SettingsIcon, inBottomNav: false, status: 'active' },
];

/** Ids de "pantalla" asignables individualmente por usuario, dentro de Gestion Humana. */
export const HR_ASSIGNABLE_MODULE_IDS = ['overtime', 'results'] as const;
export type HrAssignableModuleId = (typeof HR_ASSIGNABLE_MODULE_IDS)[number];

export const HR_ASSIGNABLE_MODULES = HR_MODULES.filter((m) => (HR_ASSIGNABLE_MODULE_IDS as readonly string[]).includes(m.id));

/** Exclusivo de Administrador de Gestion Humana - nunca se otorga a otro rol, ni con override individual. */
export const HR_ADMIN_ONLY_MODULE_IDS = ['hr-settings'] as const;

/** Pantallas por defecto de cada rol EN Gestion Humana (independientes de sus defaults en Control Operativo). */
export const HR_ROLE_DEFAULT_MODULES: Record<LccRole, HrAssignableModuleId[]> = {
  admin: ['overtime', 'results'],
  supervisor: ['overtime', 'results'],
  operator: [],
};

export function resolveEffectiveHrModules(role: LccRole, allowedModules: string[] | null): string[] {
  if (role === 'admin') return HR_ROLE_DEFAULT_MODULES.admin;
  if (allowedModules && allowedModules.length > 0) return allowedModules;
  return HR_ROLE_DEFAULT_MODULES[role];
}

export function visibleHrModules(all: ModuleDefinition[], effective: string[], role: LccRole): ModuleDefinition[] {
  return all.filter((m) => {
    if ((HR_ADMIN_ONLY_MODULE_IDS as readonly string[]).includes(m.id)) return role === 'admin';
    if ((HR_ASSIGNABLE_MODULE_IDS as readonly string[]).includes(m.id)) return effective.includes(m.id);
    return true;
  });
}

export function getVisibleHrModules(role: LccRole, allowedModules: string[] | null): ModuleDefinition[] {
  return visibleHrModules(HR_MODULES, resolveEffectiveHrModules(role, allowedModules), role);
}
